export enum Permission {
    NOTIFICATION = 'NOTIFICATION',
    LOCATION ='LOCATION',
    READ_CONTACT = 'READ_CONTACT',
    READ_STORAGE = 'READ_STORAGE'
}
